import { EditMachineNote } from './editMachineNote';
import MachineNoteType from '../machineNoteType';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import { format } from 'date-fns';
import { useState } from 'react';
import '../../../css/machines/readMachineNote.css';

const MachineNoteDetailsInfo = () => {

    const user = useSelector((state) => state?.AuthenticatedUser);
    const machineNoteDetailsData = useSelector((state) => state.MachineNoteDetailsData);

    const [editNoteData, setEditNoteData] = useState(false);

    return (
        <Box className='readMachineNote_box'>
            <Box className='readMachineNote_edit_box'>
                <Typography className='readMachineNote_title'>Les informations de la remarque</Typography>
                {(user?.id === machineNoteDetailsData?.created_by?.id && machineNoteDetailsData?.status === 'Active' && !machineNoteDetailsData?.machine?.is_archived) && <Iconify className='readMachineNote_edit_icon' icon={"ic:outline-edit"} onClick={() => setEditNoteData(true)} />}
            </Box>
            <Box className='readMachineNote_info_box'>
                <Box className='readMachineNote_icon_title_response_box'>
                    <Iconify className='readMachineNote_action_icon' icon={"f7:status"} />
                    <Typography className='readMachineNote_text'>Statut:</Typography>
                    <Typography className='readMachineNote_text_statut_controle'>{machineNoteDetailsData?.status === 'Annulee' ? 'Annulée' : machineNoteDetailsData?.status === 'Prise_en_compte' ? 'Prise en compte' : 'Active'}</Typography>
                </Box>
                <Box className='readMachineNote_icon_title_response_box'>
                    <Iconify className='readMachineNote_action_icon' icon={"fluent:scan-type-20-filled"} />
                    <Typography className='readMachineNote_text'>Type:</Typography>
                    {machineNoteDetailsData?.status === 'Active' ?
                        <MachineNoteType status={machineNoteDetailsData?.type} /> :
                        <Typography className='readMachineNote_text_statut_controle'>{machineNoteDetailsData?.type}</Typography>
                    }
                </Box>
                <Box className='readMachineNote_icon_title_response_box'>
                    <Iconify className='readMachineNote_action_icon' icon={"charm:person"} />
                    <Typography className='readMachineNote_text'>Créé par:</Typography>
                    <Typography className='readMachineNote_text_statut_controle'>
                        {machineNoteDetailsData?.created_by?.first_name && machineNoteDetailsData?.created_by?.last_name
                            ? `${machineNoteDetailsData?.created_by.first_name} ${machineNoteDetailsData?.created_by?.last_name}`
                            : machineNoteDetailsData?.anonymous_reporter_name
                                ? machineNoteDetailsData?.anonymous_reporter_name
                                : 'Inconnu'
                        }
                    </Typography>
                </Box>
                <Box className='readMachineNote_icon_title_response_box'>
                    <Iconify className='readMachineNote_action_icon' icon="ic:outline-email" />
                    <Typography className='readMachineNote_text'>Adresse e-mail:</Typography>
                    <Typography className='readMachineNote_text_statut_controle'>
                        {machineNoteDetailsData?.created_by?.email
                            ? machineNoteDetailsData?.created_by.email
                            : machineNoteDetailsData?.anonymous_reporter_email
                                ? machineNoteDetailsData?.anonymous_reporter_email
                                : 'Inconnu'
                        }
                    </Typography>
                </Box>
                <Box className='readMachineNote_icon_title_response_box'>
                    <Iconify className='readMachineNote_action_icon' icon={"formkit:date"} />
                    <Typography className='readMachineNote_text'>Créé le:</Typography>
                    <Typography className='readMachineNote_text_statut_controle'>{format(new Date(machineNoteDetailsData?.created_at), 'dd/MM/yyyy - HH:mm')}</Typography>
                </Box>
                <Box className='readMachineNote_icon_title_response_box'>
                    <Iconify className='readMachineNote_action_icon' icon={"simple-line-icons:note"} />
                    <Typography className='readMachineNote_text'>Remarque:</Typography>
                    <Typography className='readMachineNote_text_statut_controle' style={{ whiteSpace: 'pre-wrap' }}>{machineNoteDetailsData?.message}</Typography>
                </Box>
            </Box>

            {editNoteData &&
                <EditMachineNote
                    editNoteData={editNoteData}
                    setEditNoteData={setEditNoteData}
                />
            }

        </Box>
    );
}

export default MachineNoteDetailsInfo;